import React from 'react';
import { useTranslation } from 'react-i18next';
import { Autocomplete, AutocompleteChangeValue } from 'edenred-ui';
import { useFormContext } from 'react-hook-form';

import { ISelectBenefitGroups } from '@epi-models/pages/TransferPage';
import { isAutocompleteOption } from '@epi-helpers/AutocompleteHelper';
import { FormFields } from '@epi-forms/helpers';
import { TopupFormType } from '@epi-pages/LoadBenefit/components/Topup/TopupForm';

export const SelectBenefitGroups = ({ options }: ISelectBenefitGroups) => {
  const { watch, setValue } = useFormContext<TopupFormType>();
  const { t } = useTranslation();
  const benefitGroupIds = watch(FormFields.BenefitGroupIds);

  const selectedBenefitGroups = options.filter(
    opt =>
      Array.isArray(benefitGroupIds) &&
      benefitGroupIds.includes(Number(opt.value))
  );

  const handleChange = (
    event: React.SyntheticEvent,
    value: AutocompleteChangeValue
  ) => {
    if (!Array.isArray(value)) {
      setValue(FormFields.BenefitGroupIds, []);
      return;
    }

    const selectedOptions = value.filter(isAutocompleteOption);
    setValue(
      FormFields.BenefitGroupIds,
      selectedOptions.map(item => Number(item.value))
    );
  };

  return (
    <div style={{ width: 300 }}>
      <Autocomplete
        multiple
        label={t('containers.deposit_money.topup_tab.form.table.benefit_group')}
        onChange={handleChange}
        noOptionsText={t(
          'containers.deposit_money.topup_tab.form.table.no_items'
        )}
        limitTags={2}
        options={options}
        value={selectedBenefitGroups}
        getOptionKey={option => {
          if (isAutocompleteOption(option)) return `${option.value}`;
          return `${option}`;
        }}
      />
    </div>
  );
};
